import React from "react";
import styled from "styled-components";
import FormCheckbox from "../FormControls/FormCheckbox";
import { useTranslation } from "react-i18next";
import { Paragraph16Bold } from "../../Typography/Paragraph16";
import { getFlexCenter } from "../../styles";
import Icon from "../Icon/Icon";

const Root = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 29px 0 27px 0;
`;

const TitleWrapper = styled.div`
  display: flex;
  cursor: pointer;
  width: 100%;
`;

const IconWrapper = styled.div`
  ${getFlexCenter};
  width: 80px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileM}) {
    width: 50px;
  }
`;

const AccordionIcon = styled(Icon)<{ $isOpen: boolean }>`
  transform: rotateX(${({ $isOpen }) => ($isOpen ? "180deg" : "0")});
  transform-origin: center;
  transition: transform 200ms linear;
`;

const Title = styled(Paragraph16Bold)`
  cursor: pointer;
`;

const CheckboxWrapper = styled.div`
  padding-right: 45px;
`;

interface IAccordionTitle {
  title: string;
  checkboxName?: string;
  onClick: () => void;
  isOpen: boolean;
}

const AccordionTitle = ({
  title,
  checkboxName,
  onClick,
  isOpen,
}: IAccordionTitle) => {
  const { t } = useTranslation();
  return (
    <Root>
      <TitleWrapper onClick={onClick}>
        <IconWrapper>
          <AccordionIcon name="chevronDown" $isOpen={isOpen} />
        </IconWrapper>
        <Title> {t(title)} </Title>
      </TitleWrapper>
      {checkboxName && (
        <CheckboxWrapper>
          <FormCheckbox name={checkboxName} />
        </CheckboxWrapper>
      )}
    </Root>
  );
};

export default AccordionTitle;
